import Component from '../core/Component';
import {queryAll} from '../utils/dom';

export default class Slider extends Component {
    constructor(element) {
        super(element);

        this.items = queryAll('[data-ref="item"]', this.element);
        this.index = 0;
    }

    prepare() {
        this.render();
    }

    next() {
        this.index++;
        if (this.index >= this.items.length) {
            this.index = 0;
        }
        this.render();
    }

    previous() {
        this.index--;
        if (this.index < 0) {
            this.index = this.items.length-1;
        }
        this.render();
    }

    render() {
        this.items.forEach(item => {
            item.classList.remove('is-active');
        });
        this.items[this.index].classList.add('is-active');

        setTimeout(this.next.bind(this), 3000);
    }
}



// WEBPACK FOOTER //
// ./components/Slider.js